import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { MatDialog } from '@angular/material';
import { DimensionsEditorComponent } from '../ng-components/dimensions-editor/dimensions-editor.component';
import { DrawingsHolderService } from '../drawings-holder.service';
import { Dimensions } from '../object3D';
import { Size } from '../object3D/Dimensions/Size';
import { IDoubleClick } from '../Interfaces';
import { DeleteObjectComponent } from './DeleteObjectComponent';
import { ArrowHolder } from '../object3D/Dimensions/ArrowHolder';

export class config {
  text: string;
  needArrow: boolean;
  changed: boolean;
}

@Injectable()
export class EditDimensionsComponent extends ComponentBase implements IDoubleClick {
  selectedObject: Dimensions | null = null;

  constructor(
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private deleteComponent: DeleteObjectComponent
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        this.selectedObject = obj[0] instanceof Dimensions ? obj[0] : null;
      } else {
        this.selectedObject = null;
      }
    });
  }

  dblclick() {
    if (this.selectedObject) {
      this.deleteComponent.disable();
      // this.selectedObject.canBeDeleted = false;
      const size = this.selectedObject.children.filter(ch => ch instanceof Size)[0];
      const dialogRef = this.dialog.open(DimensionsEditorComponent, {
        data: this.selectedObject
      });
      dialogRef.afterClosed().subscribe((result: config | undefined) => {
        if (result) {
          const object = this.selectedObject;
          if (result.changed) {
            size.updateText(result.text);
            object.text = result.text;
          }
          this.selectedObject.getObjectByName<ArrowHolder>("firstArrow").visible = result.needArrow;
          this.selectedObject.getObjectByName<ArrowHolder>("secondArrow").visible = result.needArrow;
        }
        this.deleteComponent.enable();
      });
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/EditDimensionsComponent.ts